<template>
	<v-dialog v-model="dialog" @input="v => v || closeEditor()" max-width="500px">
		<v-card>
			<v-form>
				<v-toolbar flat dense cad>
					<v-toolbar-title class="subheading">Quick Edit</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>

				<v-divider></v-divider>
				<v-card-text>
					<div v-if="hasAccessToModify">
						<v-text-field v-model="form.firstName" :error-messages="firstNameErrors" label="First Name" required @input="$v.form.firstName.$touch()" @blur="$v.form.firstName.$touch()"></v-text-field>
						<v-text-field v-model="form.lastName" :error-messages="lastNameErrors" label="Last Name" required @input="$v.form.lastName.$touch()" @blur="$v.form.lastName.$touch()"></v-text-field>
						<!-- <v-text-field v-if="node.positionId" v-model="form.title" :error-messages="titleErrors" label="Job Title" required @input="$v.form.title.$touch()" @blur="$v.form.title.$touch()"></v-text-field>
						
						<p v-if="node.positionId" class="text-xs-left"><router-link :to="{ name: 'employeeEdit', params: { id: node.id } }">Click here</router-link> to edit the rest of this employees profile.
						</p>	
						<p v-else class="text-xs-left">{{node.name}} does not yet have a position description set up. <br>
							<router-link :to="{ name: 'employee', params: { id: node.id } }">Click here to set one up</router-link></p> -->

						<p v-if="node.positions.length == 0" class="text-xs-left">{{node.name}} does not yet have a position description set up. <br>
							<router-link :to="{ name: 'employee', params: { id: node.id } }">Click here to set one up</router-link></p>
					</div>
					<v-alert v-else :value="true" color="warning" icon="warning" class="text-xs-left" outline>
						You do not have access to edit this employee.
					</v-alert>
									
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn flat @click="closeEditor">Cancel</v-btn>
					<v-btn v-if="hasAccessToModify" color="primary" :loading="isSaving" :disabled="isSaving" flat @click="onSubmit">Save
						<span slot="loader">Saving...</span>
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { required } from 'vuelidate/lib/validators';

	export default {
		props: {
			node: {
				type: Object,
                required: false
			},
			dialog: {
                type: Boolean,
                required: true
            },
			isSaving: {
				type: Boolean,
				required: false
			},
			loggedInEmployee: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				form: {
					id: this.node.id,
					firstName: this.node.firstName,
					lastName: this.node.lastName,
					title: this.node.title,
					departmentId: this.node.department.id
				}
			};
		},
		mixins: [validationMixin],
		validations: {
			form: {
				firstName: { required },
				lastName: { required },
				title: { required }
			}
		},
		computed: {
			firstNameErrors() {
				const errors = [];
				if (!this.$v.form.firstName.$dirty) return errors;
				!this.$v.form.firstName.required && errors.push('First Name is required.');
				return errors;
			},
			lastNameErrors() {
				const errors = [];
				if (!this.$v.form.lastName.$dirty) return errors;
				!this.$v.form.lastName.required && errors.push('Last Name is required.');
				return errors;
			},
			titleErrors() {
				const errors = [];
				if (!this.$v.form.title.$dirty) return errors;
				!this.$v.form.title.required && errors.push('Job Title is required.');
				return errors;
			},
			hasAccessToModify() {
				return this.$_hasAccessToEditEmployee(this.loggedInEmployee, this.node.id);
			}
		},
		methods: {
			closeEditor() {
				this.clear();
				this.$emit('onClose');
			},
			clear() {
				this.$v.form.$reset();
				this.form = {
					id: null,
					name: null,
					title: null,
					departmentId: null
				};
			},
			onSubmit() {
				this.$emit('onSubmit', this.form);
			}
		}
	};
</script>

<style></style>
